import React, { useCallback, useMemo } from "react";
import { useField } from "formik";
import type { TriggerButtonProps } from "@design-system/overlay/triggerButtonProps";
import { ClassCombobox } from "@components/transactions/TransactionSplitV2/ClassCombobox";
import { TransactionRuleActionFormSchema } from "../constants";

interface Props {
    index: number;
    controlButtonSize?: TriggerButtonProps["size"];
}

export const ClassActionForm: React.FC<Props> = ({
    index,
    controlButtonSize,
}) => {
    const [field, , helpers] = useField<
        TransactionRuleActionFormSchema["value"]
    >(`actions.${index}.value`);

    const selectedClasses = useMemo(
        () => field.value?.classIds ?? [],
        [field.value?.classIds],
    );

    const handleClassesSelected = useCallback(
        (classIds: string[]) => {
            helpers.setValue({ classIds });
        },
        [helpers],
    );

    return (
        <ClassCombobox
            selectedClassIds={selectedClasses}
            onChange={handleClassesSelected}
            // canSelectOnlyOneClassInTheSameRoot defaults to true —
            // matches original behaviour: selecting a class deselects siblings
            triggerButtonProps={{
                variant: "primary",
                size: controlButtonSize ?? "md",
            }}
        />
    );
};
